import { Outlet } from "react-router-dom";
import { UserProfileContext } from "../contexts/UserProfileStepsContext";
import { useContext } from "react";
import Toaster from "../components/Toaster";
import { AppContext } from "../contexts/AppContext";
import logoImage from "../img/logo.png";

const RegisterUserProile = () => {
  const userContext = useContext(UserProfileContext);
  const appContext = useContext(AppContext);
  return (
    <>
      <h3 className="logo ml-5"><img src= {logoImage} className="logo"/></h3>
      {userContext.currentPage > 1 && userContext.currentPage < 5 && (
        <div className="container">
          <div className="col-md-2 offset-md-10 text-right">
            <button
              onClick={() => userContext.routeBack()}
              className="btn btn-outline-secondary modal-btn mb-3"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="13"
                height="13"
                viewBox="0 0 13 13"
                fill="#fff"
              >
                <path
                  d="M5.73836 12.7432L0.229535 7.0942C0.146067 7.00861 0.0868056 6.91589 0.0517494 6.81603C0.0172497 6.71617 0 6.60918 0 6.49506C0 6.38094 0.0172497 6.27395 0.0517494 6.17409C0.0868056 6.07424 0.146067 5.98151 0.229535 5.89592L5.73836 0.246898C5.89139 0.0899803 6.08253 0.00781295 6.31178 0.000395038C6.54159 -0.00645227 6.73997 0.0757151 6.9069 0.246898C7.07384 0.403815 7.16092 0.599819 7.16815 0.83491C7.17483 1.07057 7.0947 1.27399 6.92777 1.44518L2.83788 5.63915H12.1653C12.4018 5.63915 12.6002 5.72103 12.7604 5.8848C12.9201 6.04913 13 6.25255 13 6.49506C13 6.73757 12.9201 6.94071 12.7604 7.10447C12.6002 7.26881 12.4018 7.35097 12.1653 7.35097H2.83788L6.92777 11.5449C7.08079 11.7019 7.16092 11.9016 7.16815 12.1441C7.17483 12.3866 7.0947 12.5863 6.92777 12.7432C6.77475 12.9144 6.57999 13 6.3435 13C6.10701 13 5.9053 12.9144 5.73836 12.7432Z"
                  fill="#565555"
                />
              </svg>{" "}
              Back
            </button>
          </div>
        </div>
      )}
      <div className="container">
        <div className="col-md-12">
          <div className="step-wrapper">
            <p className="step">
              <span className="d-block-mob-steps step-count">Step {userContext.currentPage}: </span>
              <span className="step-title">
                {userContext.pageTitle[userContext.currentPage - 1]}
              </span>
            </p>
          </div>
          <p className="text-center step-p">
          Initiate profile setup, prioritizing professional objectives
          </p>
        </div>

        <div className="form-container">
          <Outlet />
        </div>
      </div>
    </>
  );
};

export default RegisterUserProile;
